export const OKR_NOT_FOUND = 'Requested detail is no longer available';
export const MIN_TITLE_LENGTH_TO_ENABLE_AI_BUTTON = 10;
